/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaSelectOne from 'DesignSystem/TysiaSelectOne/index'
import TysiaSelectOneArrow from 'DesignSystem/TysiaSelectOne/TysiaSelectOneArrow/index'
import TysiaSelectOneContent from 'DesignSystem/TysiaSelectOne/TysiaSelectOneContent/index'
import TysiaSelectOneInput from 'DesignSystem/TysiaSelectOne/TysiaSelectOneInput/index'
import TysiaSelectOneLabel from 'DesignSystem/TysiaSelectOne/TysiaSelectOneLabel/index'
import TysiaSelectOneOptions from 'DesignSystem/TysiaSelectOne/TysiaSelectOneOptions/index'
import TysiaSelectOnePopover from 'DesignSystem/TysiaSelectOne/TysiaSelectOnePopover/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/SendPatientSignatureRequestMessage/Recipients/Content",
  isInvalid,
  isSubmitting
  
}) {
let recipientsValueData = fromData.useDataValue({ viewPath,
context: 'recipients',
})
let selectedSendToPersonVaxiomIdValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'send_to_person_vaxiom_id',
})
let selectedSendToPersonVaxiomIdIsValidData = fromData.useDataIsValid({ viewPath,
context: 'selected',
path: 'send_to_person_vaxiom_id',
validate: fromValidate.number,
required: true,
})
let selectedSendToPersonVaxiomIdIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'selected',
})
let onChange = fromHelpers.useOnChange({
  children,
  viewPath,
  isInvalid,
  isSubmitting
  
})
  return (<React.Fragment
>
<TysiaSelectOne
  viewPath={`${viewPath}/TysiaSelectOne`}
 allowEmptyChoice={false}
 marginTop={0}
 data="recipients"
 from={recipientsValueData}
 data="selected.send_to_person_vaxiom_id"
 value={selectedSendToPersonVaxiomIdValueData}
 onChange={onChange}
 required={true}
 validate="/Data/validate.js number"
 invalid={!selectedSendToPersonVaxiomIdIsValidData}
 disabled={selectedSendToPersonVaxiomIdIsSubmittingData}
 size="medium"
>
{childProps => (
<React.Fragment>
<TysiaSelectOneLabel
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneLabel`}
 text="Signatory"
/>
<TysiaSelectOneContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneContent`}
>
{childProps => (
<React.Fragment>
<TysiaSelectOneInput
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneInput`}
/>
<TysiaSelectOneArrow
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneArrow`}
/>
<TysiaSelectOnePopover
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOnePopover`}
>
{childProps => (
<TysiaSelectOneOptions
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneOptions`}
/>
)}
</TysiaSelectOnePopover>
</React.Fragment>
)}
</TysiaSelectOneContent>
</React.Fragment>
)}
</TysiaSelectOne>
{children}
</React.Fragment>)
}